/* eslint-disable no-console */
import { useState, useRef, useCallback, useEffect } from 'react';
import Config from '../utils/config/config';

const R = require('ramda');

const useAudio = () => {
  // const [currStatus, setCurrStatus] = useState(false);
  const [isAudioLoaded, setIsAudioLoaded] = useState(false);
  
  const ringRef = useRef(null);
  const beepRef = useRef(null);
  const breakTuneRef = useRef(null);
  const currStatusRef= useRef(null)
  // Load audio files
  const loadAudio = useCallback(() => {
    if (ringRef.current === null) {
      try {
        // console.info('%c Loading Audio Files', 'color: grey;');
        const beepTone = `${R.prop('soundURL', Config)}beep_beep_beep.mp3`;
        const ringTone = `${R.prop('soundURL', Config)}FrontM_Ring.mp3`;
        
        ringRef.current = new Audio(ringTone);
        beepRef.current = new Audio(beepTone);
        
        ringRef.current.loop = false;
        beepRef.current.loop = false;
        
        setIsAudioLoaded(true);
      } catch (error) {
        console.error('Failed to load audio files:', error);
        ringRef.current = null;
        beepRef.current = null;
        setIsAudioLoaded(false);
      }
    }
  }, []);

  // Toggle loop status
  const toggleLoop = useCallback((val) => {
    if (!ringRef.current) return;
    // setCurrStatus(val);
    currStatusRef.current  = val;
  }, []);

  // Ring tone with interval
  const ringToneWithInterval = useCallback(() => {
    breakTuneRef.current = setInterval(() => {
      if (currStatusRef.current === true && ringRef.current) {
        ringRef.current.play().catch((error) => {
          console.error("Cannot play Ring Audio", error);
        });
      }
    }, 5000);
  }, [currStatusRef.current

  ]);

  // Play ring
  const playRing = useCallback(() => {
    //  setCurrStatus(true)
    currStatusRef.current=true
    if (!ringRef.current) {
      loadAudio();
    }
    
    if (!ringRef.current) return;
   
    ringToneWithInterval();
  }, [loadAudio, ringToneWithInterval]);

  // Pause ring
  const pauseRing = useCallback(() => {
    if (breakTuneRef.current) {
      clearInterval(breakTuneRef.current);
      breakTuneRef.current = null;
    }
    
    if (!ringRef.current) return;
    
    ringRef.current.pause();
    // setCurrStatus(false);
    currStatusRef.current =false
  }, []);

  // Play beep
  const playBeep = useCallback(() => {
    if (!beepRef.current) {
      loadAudio();
    }
    
    if (!beepRef.current) return;
    
    beepRef.current.play().catch((error) => {
      console.error('Cannot play beep', error);
    });
  }, [loadAudio]);

  // Pause beep
  const pauseBeep = useCallback(() => {
    if (!beepRef.current) return;
    beepRef.current.pause();
  }, []);

  // Disable sound
  const disableSound = useCallback(() => {
    // Clear any running intervals
    if (breakTuneRef.current) {
      clearInterval(breakTuneRef.current);
      breakTuneRef.current = null;
    }
    
    // Pause and clear audio elements
    if (ringRef.current) {
      ringRef.current.pause();
      ringRef.current = null;
    }
    
    if (beepRef.current) {
      beepRef.current.pause();
      beepRef.current = null;
    }
    
    // setCurrStatus(false);
    currStatusRef.current =false
    setIsAudioLoaded(false);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      disableSound();
    };
  }, [disableSound]);

  // Auto-load audio on mount
  useEffect(() => {
    loadAudio();
  }, [loadAudio]);

  return {
    // State
    currStatusRef,
    isAudioLoaded,
    
    // Methods
    loadAudio,
    toggleLoop,
    playRing,
    pauseRing,
    playBeep,
    pauseBeep,
    disableSound,
  };
};

export default useAudio;
